module.exports = __webpack_public_path__ + "img/1585710830.525b6516.jpg";